import React, { FC } from "react";
import PlaylistTrack from "./PlaylistTrack";
import uuid from "uuid";
import UIkit from "uikit";
import PlaylistDrop from "../../layout/dropdown/PlaylistDrop";
import { deletePlaylist } from "../../../store/actions/playlist";
import { connect } from "react-redux";
import { RootState } from "../../../store/reducers";
import { Playlist } from "../../../models/playlist";
import { Album, Track } from "../../../models/track";

const PlaylistItem: FC<{
  playlist?: Playlist;
  album?: Album;
  uid: string;
  deletePlaylist: Function;
}> = ({ playlist, uid, deletePlaylist, album }) => {
  // let show = window.innerWidth > 640
  var title: string, id: string | undefined, tracks: Track[];

  if (playlist) {
    title = playlist?.title;
    id = playlist?.id;
    tracks = playlist?.tracks;
  } else if (album) {
    title = album?.title;
    id = album?.id;
    tracks = album?.tracks;
  }

  /** @ToDo ensure modals works again
   */

  // UIkit.util.on("#js-modal-confirm", "click", function (e: Event) {
  //   e.preventDefault()
  //   e.currentTarget.blur()
  // })

  return (
    <div className="list-item" uk-scrollspy="cls:uk-animation-slide-left">
      <div className="list-info">
        <div>
          <h4 style={{ textTransform: "capitalize" }}>
            <small>{title!}</small>
          </h4>
        </div>
        <div>
          <span>
            <i className="material-icons-outlined md-24">share</i>
          </span>
          {uid === playlist?.user.id && (
            <span
              id="js-modal-confirm"
              onClick={() => {
                UIkit.modal.confirm(`Do you want to delete ${title}`).then(
                  () => {
                    deletePlaylist(id, playlist.user.id);
                  },
                  () => {}
                );
                // eslint-disable-next-line no-restricted-globals
                // let val = confirm(`Do you want to delete ${title}`);
                // if (val)
              }}
            >
              <i className="material-icons-outlined md-24">delete</i>
            </span>
          )}
          <span>
            <span>
              <i className="material-icons-outlined md-24">more_horiz</i>
            </span>
            <PlaylistDrop tracks={tracks!} />
          </span>
        </div>
      </div>
      <div className="list-content">
        {tracks! &&
          tracks!.map((track, i) => {
            let tid = uuid.v4();
            return <PlaylistTrack track={track} key={i} tid={tid} />;
          })}
        {!tracks!.length && <h4>No tracks available</h4>}
      </div>
    </div>
  );
};

const mapState = (state: RootState) => ({
  uid: state.auth.user.id,
});

export default connect(mapState, { deletePlaylist })(PlaylistItem);
